import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IbodeGraphsDal } from '../dal/ibode-graphs.dal';

@Injectable({
  providedIn: 'root',
})
export class IbodeGraphsService {
  constructor(private ibodeGraphsDal: IbodeGraphsDal) {}

  // First Row

  getPositionsPie(positions: string): Observable<any> {
    return this.ibodeGraphsDal.getPositionsPie(positions);
  }

  getLastThree(isIadeResp: boolean = false, positions: string): Observable<any> {
    return this.ibodeGraphsDal.getLastThree(isIadeResp, positions);
  }

  getTwoWeeksTeam(
    startDate: string,
    endDate: string,
    residency: string | undefined,
    positions: string,
    roles: string,
    effectifType: string,
    requestedDocuments: {
      anesthNeeds?: boolean;
      effectif?: boolean;
      nightEffectif?: boolean;
      nightGuard?: boolean;
      nightNeeds?: boolean;
      nurseNeeds?: boolean;
      residency?: boolean;
    }
  ): Observable<any> {
    return this.ibodeGraphsDal.getTwoWeeksTeam(
      startDate,
      endDate,
      residency,
      positions,
      roles,
      effectifType,
      requestedDocuments
    );
  }

  // Second Row

  getAvgLevelPerSpecialtyPerRole(
    isIadeResp: boolean = false,
    startDay: string,
    endDay: string,
    residency: string,
    specialties: string,
    roles: string
  ): Observable<any> {
    return this.ibodeGraphsDal.getAvgLevelPerSpecialtyPerRole(
      isIadeResp,
      startDay,
      endDay,
      residency,
      specialties,
      roles
    );
  }
  // Third Row

  getWaterFallPerRoleData(
    isIadeResp: boolean = false,
    startDay: string,
    endDay: string,
    residency: string,
    specialties: string,
    roles: string,
    positions: string
  ): Observable<any> {
    return this.ibodeGraphsDal.getWaterFallPerRoleData(
      isIadeResp,
      startDay,
      endDay,
      residency,
      specialties,
      roles,
      positions
    );
  }

  // Forth Row

  getBubbleDataPerRole(
    isIadeResp: boolean = false,
    residency: string,
    positions: string,
    specialties: string,
    roles: string
  ): Observable<any> {
    return this.ibodeGraphsDal.getBubbleDataPerRole(isIadeResp, residency, positions, specialties, roles);
  }

  // Fifth Row

  getFinaleGeneralStats(
    isIadeResp: boolean = false,
    residency: string,
    specialties: string,
    roles: string,
    positions: string
  ): Observable<any> {
    return this.ibodeGraphsDal.getFinaleGeneralStats(isIadeResp, residency, specialties, roles, positions);
  }

  /////////////////////////
  ////// One Onf //////////
  /////////////////////////

  // First Row

  getOneInfBarChart(nurseId: string): Observable<any> {
    return this.ibodeGraphsDal.getOneInfBarChart(nurseId);
  }

  // Second Row

  getNurseLevelEvolution(nurseId: string, startDay: string, EndDay: string): Observable<any> {
    return this.ibodeGraphsDal.getNurseLevelEvolution(nurseId, startDay, EndDay);
  }

  getNurseEvolution(nurseId: string, startDay: string, EndDay: string): Observable<any> {
    return this.ibodeGraphsDal.getNurseEvolution(nurseId, startDay, EndDay);
  }

  // Third Row

  getSpecialtyIntervention(nurseId: string, startDay: string, EndDay: string): Observable<any> {
    return this.ibodeGraphsDal.getSpecialtyIntervention(nurseId, startDay, EndDay);
  }

  getNurseRankings(nurseId: string, startDay: string, EndDay: string): Observable<any> {
    return this.ibodeGraphsDal.getNurseRankings(nurseId, startDay, EndDay);
  }

  getDoughnutData(nurseId: string, startDay: string, EndDay: string): Observable<any> {
    return this.ibodeGraphsDal.getDoughnutData(nurseId, startDay, EndDay);
  }

  // Specialties Progress
  getSpecialtiesProgress(nurseId: string): Observable<any> {
    return this.ibodeGraphsDal.getSpecialtiesProgress(nurseId);
  }

  getOneSpecialtyProgress(nurseId: string, specialtyId: string): Observable<any> {
    return this.ibodeGraphsDal.getOneSpecialtyProgress(nurseId, specialtyId);
  }

  getAllNursesReportsPDF(
    hospital: string,
    fromDate: string,
    toDate: string,
    showAnnex: boolean,
    showIndivExp: boolean,
    showRank: boolean
  ): Observable<any> {
    return this.ibodeGraphsDal.getAllNursesReportsPDF(hospital, fromDate, toDate, showAnnex, showIndivExp, showRank);
  }
}
